export enum SortField {
  ReportName = "ReportName",
  Supplier = "Supplier",
  Recurrence = "Recurrence",
  Days = "Days",
  Created = "Created",
}
